<template>
  <div class="addHappinessTipsCategoriesComponent">
    <div v-if="loading" class="text-center">
      <v-progress-circular
        class="mt-auto"
        :size="70"
        :width="7"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </div>

    <div v-else class="row">
      <div class="formulario col-sm-6 col-md-10">
        <v-form ref="form" class="mt-5 col-sm-10 col-md-6">
          <v-text-field
            color="secondary"
            underlined
            :label="'*' + $t('happinessTips.label.table.category')"
            :placeholder="$t('happinessTips.label.form.categoryNamePlaceholder')"
            :counter="100"
            :maxlength="100"
            required
            :rules="categoryNameRules"
            v-model="formData.happinessCategoryTipsName"
          ></v-text-field>

          <v-select
            v-model="formData.status"
            :label="$t('tips.label.table.status')"
            :items="listStatus"
            item-text="nameStatus"
            item-value="valueStatus"
            underlined
            required
            class="mt-5"
          ></v-select>
        </v-form>
      </div>

      <v-tooltip left>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            fab
            fixed
            bottom
            right
            dark
            large
            color="primary"
            v-bind="attrs"
            v-on="on"
            @click="submitForm"
          >
            <v-icon dark>mdi-content-save</v-icon>
          </v-btn>
        </template>
        <span>{{ $t('button.save') }}</span>
      </v-tooltip>
    </div>
  </div>
</template>

<script>
import EventBus from "@/utils/event_bus.js";
import { mapActions, mapGetters } from "vuex";
import i18n from '@/plugins/i18n';
import Swal from "sweetalert2";

import {
  HAPPINESS_TIPS_CATEGORIES_M,
  GET_STATE_LOADING,
  GET_HAPPINESS_TIPS_CATEGORIES,
  ACTION_PUT_UPDATE_HAPPINESS_TIPS_CATEGORIES,
} from "@/views/happiness-tips/categories-store/types/types.js";

export default {
  name: "DetailHappinessTipsCategoriesComponent",
  props: {
    category: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formData: {
        categoryId: this.category.happinessCategoryTipsId,
        happinessCategoryTipsName: this.category.happinessCategoryTipsName,
        status: this.category.status !== undefined ? this.category.status : true,
      },
      listStatus: [
        { idStatus: 1, nameStatus: 'Visible', valueStatus: true },
        { idStatus: 2, nameStatus: 'Oculto', valueStatus: false }
      ],
      categoryNameRules: [
        v => !!v || i18n.t('happinessTips.label.form.categoryNameRequired'),
        v => (v && v.trim().length >= 3) || i18n.t('happinessTips.label.form.categoryNameMinLength'),
        v => (v && v.length <= 50) || i18n.t('happinessTips.label.form.categoryNameMaxLength'),
        v => !this.categories.some(c => c.name && c.name.toLowerCase() === v.toLowerCase() && c.happinessCategoryTipsId !== this.category.happinessCategoryTipsId) || i18n.t('tips.label.form.categoryNameDuplicate'),
      ],
    };
  },

  computed: {
    ...mapGetters({
      loading: [`${HAPPINESS_TIPS_CATEGORIES_M}${GET_STATE_LOADING}`],
      categories: `${HAPPINESS_TIPS_CATEGORIES_M}${GET_HAPPINESS_TIPS_CATEGORIES}`,
    }),
  },

  methods: {
    ...mapActions({
      putActionUpdateCategories: `${HAPPINESS_TIPS_CATEGORIES_M}${ACTION_PUT_UPDATE_HAPPINESS_TIPS_CATEGORIES}`,
    }),

    async submitForm() {
      const isFormValid = this.$refs.form.validate();

      if (!isFormValid) {
        Swal.fire({
          icon: 'error',
          title: i18n.t('label.errorsValidation.plural.title'),
          text: i18n.t('label.errorsValidation.text'),
          confirmButtonColor: '#6E17A5'
        });
        return;
      }

      try {
        const result = await Swal.fire({
          title: i18n.t('label.confirm.title'),
          icon: 'question',
          showCancelButton: true,
          confirmButtonText: i18n.t('button.save.text'),
          cancelButtonText: i18n.t('button.cancel.text'),
          confirmButtonColor: '#6E17A5'
        });

        if (!result.isConfirmed) {
          Swal.fire({
            position: "top-end",
            icon: "info",
            title: i18n.t('label.delete.cancel'),
            showConfirmButton: false,
            timer: 2500,
          });
          return;
        }

        this.formData.happinessCategoryTipsName = this.formData.happinessCategoryTipsName.trim();
        const saveSuccess = await this.putActionUpdateCategories(this.formData);

        if (saveSuccess) {
          EventBus.$emit("reload-update-happiness-tips-categories");
        } else {
          Swal.fire({
            icon: 'error',
            title: i18n.t('label.invalid.title'),
            text: i18n.t('label.invalid.text')
          });
        }
      } catch (error) {
        console.error(i18n.t('label.failService'), error);
      }
    },
  },
};
</script>

<style lang="css" scoped>
.formulario {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5vw;
}

.row {
  display: flex;
  justify-content: center;
}

@media screen and (max-width: 425px) {
  .formulario {
    gap: 10px;
    flex-direction: column-reverse;
  }
}
</style>